if (!customElements.get("product-swatch")) {
	class ProductSwatch extends HTMLElement {
		constructor() {
			super();
			this.addEventListener("click", this.handleClick);
		}

		handleClick(e) {
			e.preventDefault();
			const target = e.currentTarget;

			document
				.querySelectorAll(".color_switcher product-swatch .swatch")
				.forEach((swatch) => {
					swatch.classList.remove("swatch_active");
				});

			target.querySelector("label.swatch").classList.add("swatch_active");
			const productUrl = this.dataset.productUrl;
			if (this.querySelector(".loading__spinner")) {
				this.querySelector(".loading__spinner").classList.remove("hidden");
			}
			// render new contents
			this.renderSections(productUrl);
		}
		getSectionsToRender() {
			return [
				{
					selector: "js-product-info",
					sectionId: this.closest("[js-product-info]")?.dataset.section,
				},
			];
		}

		getBelowFoldSectionsToRender() {
			return [
				{
					selector: "js-product-object-image-text-main-new",
					sectionId: document.querySelector(
						"[js-product-object-image-text-main-new ]"
					)?.dataset.section,
				},
				{
					selector: "js-index-object-banner-texts-main-new",
					sectionId: document.querySelector(
						"[js-index-object-banner-texts-main-new]"
					)?.dataset.section,
				},
				{
					selector: "js-product-object-full-looks-main-new",
					sectionId: document.querySelector(
						"[js-product-object-full-looks-main-new]"
					)?.dataset.section,
				},
				{
					selector: "js-index-object-tabs-columns-main-new",
					sectionId: document.querySelector(
						"[js-index-object-tabs-columns-main-new]"
					)?.dataset.section,
				},
			];
		}

		renderSections(productUrl) {
			const self = this;
			this.getSectionsToRender().forEach((section) => {
				let url = `${location.origin}${productUrl}?section_id=${section.sectionId}`;

				if (
					document.querySelector("[js-quickatc-popup-wrapper]")?.dataset
						?.bundleProduct == "true"
				) {
					url = `${location.origin}${productUrl}?view=bundle&section_id=${section.sectionId}`;
				}

				if (section.sectionId != undefined) {
					fetch(`${url}`)
						.then((response) => response.text())
						.then((html) => {
							const doc = new DOMParser().parseFromString(html, "text/html");
							const elementToReplace = document.querySelector(
								`[${section.selector}]`
							);

							if (
								elementToReplace &&
								doc.querySelector(`[${section.selector}]`)
							) {
								elementToReplace.innerHTML = "";
								elementToReplace.innerHTML = doc.querySelector(
									`[${section.selector}]`
								).innerHTML;
							}

							window.yotpoWidgetsContainer?.initWidgets();
							window.affirm?.ui?.refresh();

							switch (section.selector) {
								case "js-product-info":
									const updateUrl =
										this.closest("product-info").getAttribute(
											"data-update-url"
										);
									doc
										.querySelector("product-info")
										.setAttribute("data-update-url", updateUrl);
									document.dispatchEvent(new CustomEvent("pdp-accordion:init"));

									if (
										window.location.pathname.includes("/products/") &&
										this.closest("product-info").getAttribute(
											"data-update-url"
										) == "true"
									) {
										const productName = doc.querySelector(
											".cv-product-title__heading"
										).innerHTML;
										self.updateHistoryState(productUrl, productName);
									}

									document.dispatchEvent(
										new CustomEvent("mobile-media-slider:init")
									);
									document.dispatchEvent(
										new CustomEvent("quickAtcModelSlider:init")
									);
									document.dispatchEvent(
										new CustomEvent("stickyVariantSelect:init")
									);
									document.dispatchEvent(new CustomEvent("upsellPDP:init"));
									document.dispatchEvent(
										new CustomEvent("variantDropDown:init")
									);
									document.dispatchEvent(
										new CustomEvent("stickyAddToCart:init")
									);

									this.getBelowFoldRenderSections(productUrl);

									if (this.querySelector(".loading__spinner")) {
										this.querySelector(".loading__spinner").classList.add(
											"hidden"
										);
									}

									break;
							}
						})
						.catch(function (error) {
							console.log(error);
						});
				}
			});
		}

		getBelowFoldRenderSections(productUrl) {
			const self = this;
			this.getBelowFoldSectionsToRender().forEach((section) => {
				let url = `${location.origin}${productUrl}?section_id=${section.sectionId}`;

				if (
					document.querySelector("[js-quickatc-popup-wrapper]")?.dataset
						?.bundleProduct == "true"
				) {
					url = `${location.origin}${productUrl}?view=bundle&section_id=${section.sectionId}`;
				}

				if (section.sectionId != undefined) {
					fetch(`${url}`)
						.then((response) => response.text())
						.then((html) => {
							const doc = new DOMParser().parseFromString(html, "text/html");
							const elementToReplace = document.querySelector(
								`[${section.selector}]`
							);

							if (
								elementToReplace &&
								doc.querySelector(`[${section.selector}]`)
							) {
								elementToReplace.innerHTML = "";
								elementToReplace.innerHTML = doc.querySelector(
									`[${section.selector}]`
								).innerHTML;
							}

							switch (section.selector) {
								case "js-product-object-image-text-main-new":
									document.dispatchEvent(
										new CustomEvent("product-object-image-text-sliders:init")
									);
									break;
								case "js-product-object-full-looks-main-new":
									document.dispatchEvent(
										new CustomEvent(
											"product-object-full-looks-items-slider:init"
										)
									);
									break;
								case "js-index-object-tabs-columns-main-new":
									document.dispatchEvent(
										new CustomEvent("indexObjectTabsColumnsSlider:init")
									);
									document.dispatchEvent(
										new CustomEvent("tabsCommonScript:init")
									);
									break;
							}
						})
						.catch(function (error) {
							console.log(error);
						});
				}
			});
		}

		updateHistoryState(productUrl, productName) {
			document.title = productName;
			var newurl = `${window.location.origin}${productUrl}`;
			window.history.replaceState(
				{
					path: newurl,
				},
				"",
				newurl
			);
		}
	}

	customElements.define("product-swatch", ProductSwatch);
}
